<!--  LOADING  -->

<div class="app-loading">
	<div class="loading-spinner"></div>
</div>

<!--  END LOADING  -->
